import { Injectable } from "@angular/core";
import { MsalService } from "@azure/msal-angular";
import { AccountInfo } from "@azure/msal-browser";
import { Observable } from "rxjs";

import { FacturaEstadoModel } from "../../models/factura/factura.model";
import { BCTagModel } from "../../models/factura-estado/bc-tag.model";
import { FloatMenuOptionsModel } from "../../models/factura/float-menu-options.model";
import { RolesModel } from "../../models/factura-estado/roles.model";
import { FacturaEstadoGateway } from "../../models/factura-estado/gateways/factura-estado.gateway";

@Injectable()
export class FacturaEstadoUseCase {

  private asyncOptionsWithIconLeft: FloatMenuOptionsModel[] = [];
  private nombre_estados_factura: string = "estadosFactura";
  private nombre_estados_usuario: string = "estadosUsuario";

  constructor(private gateway: FacturaEstadoGateway, private authService: MsalService) { }

  findAll(): Observable<[FacturaEstadoModel]> {
    return this.gateway.findAll();
  }

  //Obtiene los accounts de Azure AD
  obtenerArrayAccountInfo(): AccountInfo[] {
    return this.authService.instance.getAllAccounts();
  }

  obtenerEstadosFacturaEnBCTagModel(data: any) {
    data.map((estadoData: FloatMenuOptionsModel) => {
      this.construirBCTagModel(estadoData);
    });
  }

  estadosFacConbaseEnRol() {
    //Obtiene listado de estados para las facturas
    this.asyncOptionsWithIconLeft = this.getFacturaEstadoLocalStorage();
    //Obtiene AccountInfo Array de Azure AD
    var accountInfoArray: AccountInfo[] = this.obtenerArrayAccountInfo();
    var accountInfo: AccountInfo = accountInfoArray[0];

    this.construirEstados(accountInfo,this.asyncOptionsWithIconLeft);
  }

  construirEstados(accountInfo:AccountInfo,asyncOptionsWithIconLeft: FloatMenuOptionsModel[]){
      
    let rolesResponse = this.gateway.getRoles(accountInfo.username);
    
    let bcTagModelList : BCTagModel[] = [];
    
    rolesResponse
    .subscribe({
      next: (resRoles: RolesModel[]) => {        
        resRoles.forEach((rol: RolesModel) => {          
          switch (rol.rol) {
            case 'SUFAN01.Desembolso':
              asyncOptionsWithIconLeft
                .filter(dato => dato.id == "A" || dato.id == "NA")
                .forEach((estadoData: FloatMenuOptionsModel) => {
                  bcTagModelList.push(this.construirBCTagModel(estadoData));
                });                 
              break;
            case 'SUFAN01.Auxiliar':
              asyncOptionsWithIconLeft
                .filter(dato => dato.id == "R" || dato.id == "P")
                .forEach((estadoData: FloatMenuOptionsModel) => {
                  bcTagModelList.push(this.construirBCTagModel(estadoData));
                });
              break;
            default:
              asyncOptionsWithIconLeft
                .forEach((estadoData: FloatMenuOptionsModel) => {
                  bcTagModelList.push(this.construirBCTagModel(estadoData));
                });
          }
        });   
        sessionStorage.setItem(this.nombre_estados_usuario, JSON.stringify(bcTagModelList));        
      }
    });               
  }

  comprobarEstadosFacturaLocalStorage(): boolean {
    return localStorage.getItem(this.nombre_estados_factura) === null ? false : true;
  }

  construirBCTagModel(estadoData: FloatMenuOptionsModel): BCTagModel {
    return {
      spanText: estadoData.mainText,
      value: estadoData.id
    };
  }

  //Guarda los estados de la factura en el LocalStorage
  guardarFacturaEstadoLocalStorage(data: FacturaEstadoModel[]): void {
    let options: FloatMenuOptionsModel[] = data.map((valor: FacturaEstadoModel) => {
      return {
        id: valor.codigo,
        mainText: valor.nombre
      }
    })
    localStorage.setItem(this.nombre_estados_factura, JSON.stringify(options));
  }

  getFacturaEstadoLocalStorage(): any {
    return JSON.parse(localStorage.getItem(this.nombre_estados_factura)!);
  }

  getUsuarioEstadoSessionStorage(): any {
    return JSON.parse(sessionStorage.getItem(this.nombre_estados_usuario)!);
  }

}